import HashLoader from "react-spinners/HashLoader";
import { COLORS } from "@/constants/Colors/colors";

export default function Hash({ color }) {
  return <HashLoader size={22} color={color || COLORS.WHITE} />;
}
